import { TrashIcon } from '@heroicons/react/24/outline'
import { Button } from '@material-tailwind/react'
import React from 'react'
import { useSelector } from 'react-redux'

const PickupList = ({ pickupList, handleUpdateModal, setPickupId, setRequestId, deletePickup }) => {
  const { isAuthenticated, userProfile } = useSelector(
    (state) => state.user
  )

  return (
    <div className='overflow-hidden rounded-[24px] border border-slate-200 bg-white shadow-[0_18px_42px_rgba(15,23,42,0.07)]'>
      <div className='overflow-x-auto'>
        <table className='min-w-full border-separate border-spacing-0'>
          <thead>
            <tr className='bg-[#fffaf6]'>
              <th className='border-b border-slate-200 px-5 py-4 text-left text-xs font-[GilroyBold] uppercase tracking-[0.14em] text-[#bf7b52]'>Request ID</th>
              <th className='border-b border-slate-200 px-5 py-4 text-left text-xs font-[GilroyBold] uppercase tracking-[0.14em] text-[#bf7b52]'>Client</th>
              <th className='border-b border-slate-200 px-5 py-4 text-left text-xs font-[GilroyBold] uppercase tracking-[0.14em] text-[#bf7b52]'>Warehouse</th>
              <th className='border-b border-slate-200 px-5 py-4 text-left text-xs font-[GilroyBold] uppercase tracking-[0.14em] text-[#bf7b52]'>Pickup Slot</th>
              <th className='border-b border-slate-200 px-5 py-4 text-left text-xs font-[GilroyBold] uppercase tracking-[0.14em] text-[#bf7b52]'>Pickup Boy</th>
              <th className='border-b border-slate-200 px-5 py-4 text-center text-xs font-[GilroyBold] uppercase tracking-[0.14em] text-[#bf7b52]'>Status</th>
              <th className='border-b border-slate-200 px-5 py-4 text-center text-xs font-[GilroyBold] uppercase tracking-[0.14em] text-[#bf7b52]'>Action</th>
            </tr>
          </thead>
          <tbody>
            {pickupList?.length ? pickupList.map((item) => (
              <tr key={item.id} className='transition-colors hover:bg-slate-50/70'>
                <td className='border-b border-slate-100 px-5 py-4 text-[13px] font-[GilroyBold] text-slate-900'>{item.requestId}</td>
                <td className='border-b border-slate-100 px-5 py-4 text-[13px] font-[GilroyMedium] text-slate-700'>{item?.userName || '-'}</td>
                <td className='border-b border-slate-100 px-5 py-4 text-[13px] font-[GilroyMedium] text-slate-700'>{item.location?.pinCode || '-'}</td>
                <td className='border-b border-slate-100 px-5 py-4 text-[13px] font-[GilroyMedium] text-slate-700'>{item.date || '-'}{item.time ? `, ${item.time}` : ''}</td>
                <td className='border-b border-slate-100 px-5 py-4 text-[13px] font-[GilroyMedium] text-slate-700'>{item?.pickupBoy?.name || '-'}</td>
                <td className='border-b border-slate-100 px-5 py-4 text-center'>
                  <span className='inline-flex rounded-full border border-slate-200 bg-slate-50 px-2.5 py-1 text-[11px] font-[GilroyMedium] capitalize text-slate-700'>{item.pickupStatus || '-'}</span>
                </td>
                <td className='border-b border-slate-100 px-5 py-4'>
                  <div className='flex items-center justify-center gap-2'>
                    {isAuthenticated && userProfile?.role === "admin" ? <Button onClick={() => {
                      setPickupId(item?.id)
                      setRequestId(item?.requestId)
                      handleUpdateModal()
                    }} className='rounded-full bg-[#f97316] px-4 py-2 text-[11px] font-[GilroyBold] text-white shadow-none hover:bg-[#ea580c]'>Update Request</Button> : <span className='text-[12px] text-slate-400'>-</span>}
                    {userProfile?.role === "admin" && <button type='button' onClick={() => {
                      deletePickup(item?.id)
                    }} className='rounded-full p-2 text-red-600 transition-colors hover:bg-red-50'><TrashIcon className='h-4 w-4' /></button>}
                  </div>
                </td>
              </tr>
            )) : (
              <tr>
                <td colSpan={7} className='px-5 py-16 text-center'>
                  <p className='text-base font-[GilroyMedium] text-slate-500'>No pickup requests found</p>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default PickupList
